import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getOidcConfigurationsForCurrentSubdomain } from '@api';

export const securityOidcConfigurationsBySubdomainGetSlice = createGetAsyncSlice({
	name: 'SecurityOidcConfigurationsBySubdomain',
	receive: true,
	request: true,
	requestHandler: getOidcConfigurationsForCurrentSubdomain,
	retainDataOnRequest: true
});
